<template>
  <div class="corporate-client-management-box">

    <modal v-bind:open="showInvitePopup" v-bind:title="bundle.id_12605" v-on:close="cancelInvitePopup">
      <global-errors v-bind:value="inviteErrors"/>
      <label class="form-label" for="invitationEmail">{{ bundle.id_12606 }}</label>
      <input id="invitationEmail"
             v-model="invitationEmail"
             class="form-control"
             name="invitationEmail"
             type="email"
             v-bind:placeholder="bundle.id_12607"
             v-bind:required="true"
             v-on:keyup.enter="submitInvite()"/>
      <template v-slot:footer="">
        <button id="invitationEmailButton"
                class="btn btn-success"
                type="submit"
                v-bind:class="{'disabled': submittingInvite}"
                @click="submitInvite()">
          {{ bundle.id_12608 }}
        </button>
      </template>
    </modal>

    <!-- Nav tabs for non-mobile -->
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs d-none d-sm-flex" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="nav-management"
                    class="nav-link"
                    role="tab"
                    type="button"
                    v-bind:class="{'active': activeTab === 'management'}"
                    @click="changeTab('management')">
              {{ bundle.id_12576 }}
              <i v-if="loading" class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button id="nav-stats"
                    class="nav-link"
                    role="tab"
                    type="button"
                    v-bind:class="{'active': activeTab === 'stats'}"
                    @click="changeTab('stats')">
              {{ bundle.id_12577 }}
              <i v-if="loading" class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Selector for mobile -->
    <div class="row">
      <div class="col-12">
        <div class="d-block d-sm-none mb-4">
          <select class="form-select" v-on:change="changeTab($event.target.value)">
            <option value="management">{{ bundle.id_12576 }}</option>
            <option value="stats">{{ bundle.id_12577 }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="tab-content table-responsive-md">
      <div class="row">
        <global-errors v-bind:value="errors"/>

        <div v-if="successes.length > 0">
          <div v-for="(success, i) in successes" v-bind:key="i" class="alert alert-success d-block">{{ success }}</div>
        </div>
      </div>

      <div id="management"
           class="tab-pane fade"
           role="tabpanel"
           v-bind:class="{'active show': activeTab === 'management'}">
        <div class="row">
          <div class="col-12 col-md-3">
            <button class="btn btn-success"
                    v-bind:class="{'disabled': loading}"
                    @click="openInvitePopup()">
              {{ bundle.id_12604 }}
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 max-users-box">
                <span class="mb4">{{ bundle.id_12578 }} {{ persons.length }}</span>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="table-wrapper">
              <table id="personsTable" class="table mb-4 table-hover">
                <thead>
                <tr>
                  <th>{{ bundle.id_12579 }}</th>
                  <th>{{ bundle.id_12580 }}</th>
                  <th style="width: 8rem;">{{ bundle.id_12581 }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="person in persons" :key="person.id">
                  <td>{{ person.name }}</td>
                  <td class="allow-break">{{ person.email }}</td>
                  <td class="actions text-end">
                    <a v-if="!person.active" class="btn-text ms-2"
                       v-bind:class="{'disabled': loading}"
                       v-bind:title="bundle.id_12628"
                       @click="resendActivation(person)">
                      <i class="fa-light fa-envelope"></i>
                    </a>
                    <a v-if="admins.some(a => a.id !== person.id)" class="btn-text ms-2"
                       v-bind:class="{'disabled': loading}"
                       v-bind:title="bundle.id_12629"
                       @click="deleteSubscription(person)">
                      <i class="fa-light fa-trash-alt"></i>
                    </a>
                  </td>
                </tr>
                <tr v-if="loadingPersons">
                  <i class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12">
            <div class="table-wrapper">
              <table class="table mb-4 table-hover">
                <thead>
                <tr>
                  <th>{{ bundle.id_12583 }}</th>
                  <th>{{ bundle.id_12584 }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="admin in admins" :key="admin.id">
                  <td>{{ admin.name }}</td>
                  <td class="allow-break">{{ admin.email }}</td>
                </tr>
                <tr v-if="loadingAdmins">
                  <i class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="table-wrapper">
              <table class="table mb-4 table-hover">
                <thead>
                <tr>
                  <th colspan="3">{{ bundle.id_12585 }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="contact in contacts" :key="contact.id">
                  <td>{{ contact.name }}</td>
                  <td class="allow-break">{{ contact.email }}</td>
                  <td>{{ bundle.id_12586 }}</td>
                </tr>
                <tr v-if="corporateClient != null && corporateClient.administrator != null "
                    :key="corporateClient.administrator.id">
                  <td>{{ corporateClient.administrator.name }}</td>
                  <td class="allow-break">{{ corporateClient.administrator.mail }}</td>
                  <td>{{ bundle.id_12587 }}</td>
                </tr>
                <tr v-if="loadingContacts">
                  <i class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12">
            <div class="table-wrapper">
              <table class="table mb-4 table-hover">
                <thead>
                <tr>
                  <th>{{ bundle.id_12588 }}</th>
                  <th>{{ bundle.id_12589 }}</th>
                </tr>
                </thead>
                <tbody v-if="corporateClient !== null">
                <tr v-for="corporateClientHost in corporateClient.corporateClientHosts"
                    :key="corporateClientHost.id">
                  <td>{{ corporateClientHost.host.name }}</td>
                  <td class="ip-access-box">
                    <span v-if="corporateClientHost.ipAccess && corporateClient.ipAccess" class="check"><i
                        class="fas fa-check fa-lg"/></span>
                    <span v-else class="cross"><i class="fas fa-xmark-large fa-lg"/></span>
                  </td>
                </tr>
                <tr v-if="loadingCorporateClient">
                  <i class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      <div id="stats"
           class="tab-pane fade"
           role="tabpanel"
           v-bind:class="{'active show': activeTab === 'stats'}">
        <div class="row">
          <div class="col-12">
            <div class="table-wrapper">
              <table class="table mb-4 table-hover">
                <thead>
                <tr>
                  <th>{{ bundle.id_12590 }}</th>
                  <th>{{ bundle.id_12591 }}</th>
                </tr>
                </thead>
                <tbody v-if="readData !== null">
                <tr v-for="read in readData"
                    :key="read.host + read.title">
                  <td>{{ read.host }}</td>
                  <td>
                    <span>{{ read.title }}</span>
                  </td>
                </tr>
                <tr v-if="loadingReadData">
                  <i class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="table-wrapper col-6 col-md-4">
                <table class="table mb-4 table-hover">
                  <thead>
                  <tr>
                    <th>{{ bundle.id_12592 }}</th>
                  </tr>
                  </thead>
                  <tbody v-if="activated !== null">
                  <tr>
                    <td>
                      <span style="text-align: center;">{{ activated }}%</span>
                    </td>
                  </tr>
                  <tr v-if="loadingPersons">
                    <i class="fa fa-loading-black-16" style="margin-left: 0.5rem;"></i>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "corporate-client-management-box",
  props: {
    corporateClientId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      contextPath: window.contextPath,
      corporateClient: null,
      persons: [],
      admins: [],
      contacts: [],
      readData: [],
      activated: 0,
      showInvitePopup: false,
      submittingInvite: false,
      invitationEmail: "",
      loadingPersons: true,
      loadingCorporateClient: true,
      loadingAdmins: true,
      loadingContacts: true,
      loadingReadData: true,
      errors: [],
      successes: [],
      inviteErrors: [],
      activeTab: "management",
      bundle: {
        id_12576: "Manage subscription",
        id_12577: "Subscription usage",
        id_12578: "User count",
        id_12579: "Name",
        id_12580: "Email",
        id_12581: "Actions",
        id_12583: "Subscription administrator",
        id_12584: "Email",
        id_12585: "Contacts",
        id_12586: "Your ref",
        id_12587: "Our ref",
        id_12588: "Media subscriptions",
        id_12589: "IP access",
        id_12590: "Media",
        id_12591: "Title",
        id_12592: "Activation rate",
        id_12604: "Invite new subscriber",
        id_12605: "Invite new subscriber",
        id_12606: "Email",
        id_12607: "mail@nordiskemedier.dk",
        id_12608: "Send invitation",
        id_12609: "Failed to load persons.",
        id_12610: "Failed to load admins.",
        id_12611: "Failed to load contacts.",
        id_12612: "Failed to load company information.",
        id_12613: "Failed to load read articles.",
        id_12614: "Failed to send invitation email.",
        id_12615: "Email not correctly formatted.",
        id_12619: "Failed to delete subscription for ",
        id_12620: "Successfully sent invitation email.",
        id_12621: "Successfully removed subscription for ",
        id_12628: "Resend activation email",
        id_12629: "Delete",
        id_12630: "Could not resend an activation email for: ",
        id_12631: "Activation mail has been resend to "
      }
    }
  },
  created: function () {
    this.loadPersons();
    this.loadCorporateClient();
    this.loadAdmins();
    this.loadContacts();
    this.loadReadData();
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
  },
  methods: {
    async loadPersons() {
      this.loadingPersons = true;
      try {
        this.$services.corporateClientSecureService.loadPersons(this.corporateClientId)
            .then(data => {
              this.persons = data;
              let tmp = 0;
              for (var i in this.persons) {
                if (this.persons[i].active) {
                  tmp++;
                }
              }
              this.activated = (tmp / this.persons.length * 100).toFixed(2);
            }).catch(err => {
          console.error(err);
          this.errors.push(this.bundle.id_12609);
        }).finally(() => {
          this.loadingPersons = false;
        });
      } catch (e) {
        console.error(e);
        this.errors.push(this.bundle.id_12609);
      }
    },
    async loadAdmins() {
      this.loadingAdmins = true;
      try {
        this.$services.corporateClientSecureService.loadAdmins(this.corporateClientId)
            .then(data => {
              this.admins = data;
            }).catch(err => {
          console.error(err);
          this.errors.push(this.bundle.id_12610);
        }).finally(() => {
          this.loadingAdmins = false;
        });
      } catch (e) {
        console.error(e);
        this.errors.push(this.bundle.id_12610);
      }
    },
    async loadContacts() {
      this.loadingContacts = true;
      try {
        this.$services.corporateClientSecureService.loadContacts(this.corporateClientId)
            .then(data => {
              this.contacts = data;
            }).catch(err => {
          console.error(err);
          this.errors.push(this.bundle.id_12611);
        }).finally(() => {
          this.loadingContacts = false;
        });
      } catch (e) {
        console.error(e);
        this.errors.push(this.bundle.id_12611);
      }
    },
    async loadCorporateClient() {
      this.loadingCorporateClient = true;
      try {
        this.$services.corporateClientSecureService.loadById(this.corporateClientId)
            .then(data => {
              this.corporateClient = data;
            }).catch(err => {
          console.error(err);
          this.errors.push(this.bundle.id_12612);
        }).finally(() => {
          this.loadingCorporateClient = false;
        });
      } catch (e) {
        console.error(e);
        this.errors.push(this.bundle.id_12612);
      }
    },
    async loadReadData() {
      this.loadingReadData = true;
      try {
        this.$services.corporateClientSecureService.loadReadData(this.corporateClientId)
            .then(data => {
              this.readData = data;
            }).catch(err => {
          console.error(err);
          this.errors.push(this.bundle.id_12613);
        }).finally(() => {
          this.loadingReadData = false;
        });
      } catch (e) {
        console.error(e);
        this.errors.push(this.bundle.id_12613);
      }
    },
    async deleteSubscription(person) {
      if (!this.loading) {
        this.loadingPersons = true;
        var tmpErrors = [];
        try {
          await this.$services.corporateClientSecureService.deleteSubscription(person.id, this.corporateClientId)
              .then().catch(err => {
                console.error(err);
                tmpErrors.push(this.bundle.id_12619 + person.name);
              }).finally(() => {
                this.loadingPersons = false;
              });
        } catch (e) {
          console.error(e);
          tmpErrors.push(this.bundle.id_12619 + person.name);
        }
        await this.loadPersons().then(() => {
          if (tmpErrors.length === 0) {
            this.successes.push(this.bundle.id_12621 + person.name);
          } else {
            for (const i in tmpErrors) {
              this.errors.push(tmpErrors[i]);
            }
          }
        });
      }
    },
    openInvitePopup() {
      this.showInvitePopup = true;
    },
    closeInvitePopup() {
      this.showInvitePopup = false;
      this.invitationEmail = "";
    },
    async submitInvite() {
      this.submittingInvite = true;
      this.inviteErrors = [];
      try {
        await this.$services.corporateClientSecureService.invitePerson(this.invitationEmail, this.corporateClientId)
            .then().catch(err => {
              console.error(err);
              if (err.response !== undefined && err.response.data.length > 0 && err.code === "ERR_BAD_REQUEST") {
                for (let i = 0; i < err.response.data.length; i++) {
                  this.inviteErrors.push(err.response.data[0].message);
                }
              } else if (err.response !== undefined && err.response.data.length === 0 && err.code === "ERR_BAD_REQUEST") {
                this.inviteErrors.push(this.bundle.id_12615);
              } else {
                this.inviteErrors.push(this.bundle.id_12614);
              }
            });
      } catch (e) {
        console.error(e);
        this.inviteErrors.push(this.bundle.id_12614);
      }

      this.submittingInvite = false;
      if (this.inviteErrors.length === 0) {
        this.successes.push(this.bundle.id_12620);
        this.closeInvitePopup();
      }
    },
    cancelInvitePopup() {
      this.showInvitePopup = false;
      this.invitationEmail = "";
    },
    changeTab(tabId) {
      this.activeTab = tabId;
    },
    async resendActivation(person) {
      if (!this.loading) {
        this.loadingPersons = true;
        var tmpErrors = [];
        try {
          await this.$services.personSecureService.resendActivation(person.id)
              .then().catch(err => {
                console.error(err);
                tmpErrors.push(this.bundle.id_12630 + person.name);
              }).finally(() => {
                this.loadingPersons = false;
              });
        } catch (e) {
          console.error(e);
          tmpErrors.push(this.bundle.id_12630 + person.name);
        } finally {
          if (tmpErrors.length === 0) {
            this.successes.push(this.bundle.id_12631 + person.name);
          } else {
            for (const i in tmpErrors) {
              this.errors.push(tmpErrors[i]);
            }
          }
        }
      }
    }
  },
  computed: {
    loading: function () {
      return this.loadingPersons || this.loadingCorporateClient || this.loadingAdmins || this.loadingContacts || this.loadingReadData;
    }
  }
};
</script>

<style lang="less" scoped>
.corporate-client-management-box {
  #invitationEmail {
    width: 100%;
  }

  .table-wrapper {
    overflow-x: auto;

    .allow-break {
      word-break: break-all;
    }

    #personsTable {
      tr {
        min-height: 55px;
      }

      td {
        min-height: 55px;
      }

      .actions {
        * {
          cursor: pointer;
        }
      }
    }

    thead tr th {
      background-color: #fdfdfd;
      color: #000;
      border-bottom-color: #000;
      border-bottom-style: solid;
      border-bottom-width: 1px;
      font-weight: 700;
    }
  }

  .nav {
    margin-bottom: 25px;
  }

  .max-users-box {
    text-align: right;
  }

  .ip-access-box {
    .check {
      color: green;
    }

    .cross {
      color: red;
    }
  }
}
</style>